jQuery(document).on("click", ".navbar-one__mini-cart-btn", function (e) {
  e.preventDefault();
  jQuery(".mini-cart-container").toggleClass("is-open");
  jQuery("body").toggleClass("modal-open");
  jQuery(".fulfilment-modal__background").toggleClass("is-open");
});

(function ($) {
  "use strict";

  function initMiniCartUpsellSliders() {
    if (typeof Glide === "undefined") {
      return;
    }

    const sliders = document.querySelectorAll(
      '[id^="mini-cart-upsell-slider-"]'
    );

    if (sliders.length === 0) {
      return;
    }

    sliders.forEach((slider) => {
      if (slider.classList.contains("glide--initialized")) {
        return;
      }

      const glideSlider = new Glide(slider, {
        type: "carousel",
        perView: 1.35,
        gap: 16,
        autoplay: false,
        hoverpause: true,
        animationDuration: 1000,
        breakpoints: {
          768: {
            perView: 1.3,
          },
          576: {
            perView: 1.3,
          },
        },
      });

      glideSlider.mount();
    });
  }

  $(document).ready(function () {
    initMiniCartUpsellSliders();
  });

  $(document.body).on(
    "wc_fragments_loaded wc_fragments_refreshed added_to_cart",
    function () {
      setTimeout(function () {
        // Slider re-initialization disabled
      }, 100);
    }
  );
})(jQuery);

function deleteCartItem(element, cart_item_key) {
  event.preventDefault();

  var cartItem = element.closest(".woocommerce-mini-cart-item");
  if (!cartItem) return false;

  cartItem.style.opacity = "0.5";

  var existingOverlays = document.querySelectorAll(".cart_list.product_list_widget .mini-cart-loading-overlay");
  existingOverlays.forEach(function (overlay) {
    overlay.parentNode.removeChild(overlay);
  });

  var productListWidget = document.querySelector(".cart_list.product_list_widget");
  if (productListWidget) {
    var overlay = document.createElement("div");
    overlay.className = "mini-cart-loading-overlay";
    productListWidget.appendChild(overlay);
  }

  var xhr = new XMLHttpRequest();
  xhr.open("POST", wc_add_to_cart_params.ajax_url, true);
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

  xhr.onload = function () {
    if (xhr.status === 200) {
      try {
        var response = JSON.parse(xhr.responseText);
        if (response.success) {
          cartItem.parentNode.removeChild(cartItem);

          if (response.data && response.data.subtotal) {
            var subtotalElement = document.querySelector(".woocommerce-mini-cart__total");
            if (subtotalElement) {
              subtotalElement.innerHTML = response.data.subtotal;
            }
          }

          if (response.data.is_empty) {
            refreshMiniCart();
          } else {
            enhanceQuantityInputs();
          }

          var cartCount = document.querySelector(".mini-cart-count");
          if (cartCount && response.data.cart_count !== undefined) {
            cartCount.textContent = response.data.cart_count;
          }

          var cartRemovedEvent = new CustomEvent('cart_item_removed');
          document.body.dispatchEvent(cartRemovedEvent);
        } else {
          cartItem.style.opacity = "1";
        }
      } catch (e) {
        cartItem.style.opacity = "1";
      }

      setTimeout(function () {
        if (overlay && productListWidget.contains(overlay)) {
          productListWidget.removeChild(overlay);
        }
      }, 300);
    } else {
      cartItem.style.opacity = "1";
      if (overlay && productListWidget.contains(overlay)) {
        productListWidget.removeChild(overlay);
      }
    }
  };

  xhr.onerror = function () {
    cartItem.style.opacity = "1";
    if (overlay && productListWidget.contains(overlay)) {
      productListWidget.removeChild(overlay);
    }
  };

  xhr.send(
    "action=simple_remove_from_cart&cart_item_key=" +
    encodeURIComponent(cart_item_key)
  );

  return false;
}

function updateCartTotals() {
  var existingOverlays = document.querySelectorAll(".cart_list.product_list_widget .mini-cart-loading-overlay");
  existingOverlays.forEach(function (overlay) {
    overlay.parentNode.removeChild(overlay);
  });

  var productListWidget = document.querySelector(".cart_list.product_list_widget");
  var overlay = null;

  if (productListWidget) {
    overlay = document.createElement("div");
    overlay.className = "mini-cart-loading-overlay";
    productListWidget.appendChild(overlay);
  }

  var xhr = new XMLHttpRequest();
  xhr.open("POST", wc_add_to_cart_params.ajax_url, true);
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

  xhr.onload = function () {
    if (xhr.status === 200) {
      try {
        var response = JSON.parse(xhr.responseText);
        if (response.success && response.data.subtotal) {
          var subtotalElement = document.querySelector(
            ".woocommerce-mini-cart__total"
          );
          if (subtotalElement) {
            subtotalElement.innerHTML = response.data.subtotal;
          }
        }
      } catch (e) {
        // Silent error handling
      }

      if (overlay && productListWidget.contains(overlay)) {
        productListWidget.removeChild(overlay);
      }
    }
  };

  xhr.onerror = function () {
    if (overlay && productListWidget.contains(overlay)) {
      productListWidget.removeChild(overlay);
    }
  };

  xhr.send("action=get_cart_totals");
}

function refreshMiniCart() {
  var existingOverlays = document.querySelectorAll(".cart_list.product_list_widget .mini-cart-loading-overlay");
  existingOverlays.forEach(function (overlay) {
    overlay.parentNode.removeChild(overlay);
  });

  var productListWidget = document.querySelector(".cart_list.product_list_widget");
  var overlay = null;

  if (productListWidget) {
    overlay = document.createElement("div");
    overlay.className = "mini-cart-loading-overlay";
    productListWidget.appendChild(overlay);
  }

  var xhr = new XMLHttpRequest();
  xhr.open("POST", wc_add_to_cart_params.ajax_url, true);
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

  xhr.onload = function () {
    if (xhr.status === 200) {
      try {
        var response = JSON.parse(xhr.responseText);
        if (response.success && response.data.mini_cart_html) {
          var miniCartWrapper = document.querySelector(
            ".woocommerce-mini-cart__wrapper"
          );
          if (miniCartWrapper) {
            miniCartWrapper.innerHTML = response.data.mini_cart_html;
            enhanceQuantityInputs();
          }

          if (typeof initMiniCartUpsellSliders === "function") {
            setTimeout(function () {
              // Slider re-initialization disabled
            }, 100);
          }
        }
      } catch (e) {
        // Silent error handling
      }

      if (overlay && productListWidget.contains(overlay)) {
        productListWidget.removeChild(overlay);
      }
    }
  };

  xhr.onerror = function () {
    if (overlay && productListWidget.contains(overlay)) {
      productListWidget.removeChild(overlay);
    }
  };

  xhr.send("action=get_refreshed_mini_cart");
}

function enhanceQuantityInputs() {
  document.querySelectorAll(".quantity").forEach((quantityDiv) => {
    const input = quantityDiv.querySelector(".qty");
    if (input) {
      enhanceNumberInput(input);
    }
  });
}

jQuery(document).on(
  "change",
  ".woocommerce-mini-cart-item__qty .qty",
  function (e) {
    var $input = jQuery(this);
    var newVal = parseInt($input.val(), 10);
    var cartItemKey = $input.data("cart_item_key");
    var $cartItem = $input.closest(".woocommerce-mini-cart-item");

    if (isNaN(newVal) || newVal < 1) {
      newVal = 1;
      $input.val(1);
    }

    jQuery('.cart_list.product_list_widget .mini-cart-loading-overlay').remove();

    var $productListWidget = jQuery('.cart_list.product_list_widget');
    var $overlay = jQuery('<div class="mini-cart-loading-overlay"></div>');
    $productListWidget.append($overlay);

    jQuery.ajax({
      type: "POST",
      url: wc_add_to_cart_params.ajax_url,
      data: {
        action: "update_mini_cart_quantity",
        cart_item_key: cartItemKey,
        quantity: newVal,
      },
      success: function (response) {
        if (response.success) {
          if (response.data && response.data.subtotal) {
            var subtotalElement = jQuery('.woocommerce-mini-cart__total');
            if (subtotalElement.length) {
              subtotalElement.html(response.data.subtotal);
            }
          }

          var quantityDisplay = $cartItem.find(".product-quantity");
          if (quantityDisplay.length) {
            quantityDisplay.text(newVal);
          }

          if (response.data && response.data.line_total) {
            var $priceElement = $cartItem.find(".woocommerce-mini-cart-item__price .quantity");
            if ($priceElement.length) {
              $priceElement.html(response.data.line_total);
            }
          }

          if (response.data && response.data.lead_time) {
            $cartItem.find('.cart_item__product-meta .variation dt').each(function () {
              var $dt = jQuery(this);
              if ($dt.text().trim() === 'Lead Time:') {
                var $dd = $dt.next('dd');
                if ($dd.length) {
                  $dd.html('<p>' + response.data.lead_time + '</p>');
                }
              }
            });
          }

          if (newVal === 0) {
            var cartRemovedEvent = new CustomEvent('cart_item_removed');
            document.body.dispatchEvent(cartRemovedEvent);
          }
        }
      },
      error: function () {
        // Silent error handling
      },
      complete: function () {
        setTimeout(function () {
          $overlay.remove();
        }, 300);
      },
    });
  }
);
